module.exports = __webpack_public_path__ + "static/img/ic_arrow_gray_both.7680168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_arrow_gray_both.png
// module id = +51S
// module chunks = 1